'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webSso = require('@vezeeta/web-sso');

var _webUtils = require('@vezeeta/web-utils');

var _schedules = require('../actions/schedules');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(loadSchedules),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getVezeetaScheduleSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(schedulesSaga);

function loadSchedules() {
  var schedulesApi, schedulesApiResponse;
  return _regenerator2.default.wrap(function loadSchedules$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          schedulesApi = new _webSso.AuthApi();
          _context.next = 3;
          return schedulesApi.get(_webUtils.Urls.getRamadanSchedule);

        case 3:
          schedulesApiResponse = _context.sent;

          if (!_webUtils.STATUS.isSuccess(schedulesApiResponse.status)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({
            type: _schedules.SCHEDULES.SUCCEEDED,
            schedules: schedulesApiResponse.data
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)({
            type: _schedules.SCHEDULES.FAILED,
            schedules: schedulesApiResponse.data
          });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getVezeetaScheduleSaga(action) {
  var vezeetaSchedulesApi, header, response;
  return _regenerator2.default.wrap(function getVezeetaScheduleSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          vezeetaSchedulesApi = new _webUtils.API();
          header = [{
            key: 'countryid',
            value: '' + action.payload.countryId
          }, {
            key: 'languageid',
            value: '' + action.payload.languageId
          }, {
            key: 'RegionId',
            value: '' + action.payload.regionId
          }];
          _context2.next = 4;
          return vezeetaSchedulesApi.get(_webUtils.Urls.getVezeetaSchedule + '?RoomKeys=' + action.payload.roomKey + '&AccountKeys=' + action.payload.accountKey + '&page=1&StartDate=' + action.payload.date + '&NumberOfDays=1', header);

        case 4:
          response = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return (0, _effects.put)((0, _schedules.getVezeetaSchedulesSucceeded)(_extends({}, response.data && response.data[0])));

        case 8:
          _context2.next = 12;
          break;

        case 10:
          _context2.next = 12;
          return (0, _effects.put)((0, _schedules.getVezeetaSchedulesFailed)(_extends({}, response)));

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function schedulesSaga() {
  return _regenerator2.default.wrap(function schedulesSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_schedules.SCHEDULES.LOADING, loadSchedules);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_schedules.VEZEETA_SCHEDULE.FETCH, getVezeetaScheduleSaga);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = schedulesSaga;
module.exports = exports['default'];